<template>
  <div class="fts-lite-device-preview">
    <template v-if="isReady">
      <div class="device-preview__left"></div>

      <div class="device-content device-preview__center">
        <fts-device
          :device="device"
          :web-url="deviceWebUrl"
          :app-url="deviceAppUrl"
          ref="fts-device"
        />
      </div>

      <div class="device-preview__right">
        <div class="device-preview__onboarding">
          <div class="onboarding-title">Download mobile app</div>

          <div class="onboarding-qr-code">
            <qrcode 
              :value="downloadLink"
              :size="145"
              render-as="svg"
            ></qrcode>
          </div>

          <div class="onboarding-seperator">or</div>

          <fts-btn 
            color="primary" 
            text-transform-init 
            box-shadow-none 
            v-clipboard:copy="downloadLink" 
            v-clipboard:success="clipboardOnSuccess" 
            v-clipboard:error="clipboardOnError" 
            class="onboarding-link-btn"
          >
            <font-awesome-icon :icon="['fas', 'link']" />
            Copy link
          </fts-btn>
        </div>
      </div>
    </template>

    <fts-spinner
      full-screen
      variant="rive"
      v-else
    />
  </div>
</template>

<script>
import Vue from 'vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

import qrcode from 'qrcode.vue';

import webAppConfig from '../commons/webApp.config';
import LocalStorageService from '../store/LocalStorageService';

import FTSBtn from '../elements/FTSBtn';
import FTSDevice from '../device-preview/FTSDevice';
import FTSSpinner from '../elements/FTSSpinner.vue';
import FTSTippy from '../elements/FTSTippy';

export default {
  components: {
    qrcode,
    'fts-btn': FTSBtn,
    'fts-device': FTSDevice,
    'fts-spinner': FTSSpinner,
    'fts-tippy': FTSTippy
  },
  data: () => ({
    isReady: false,
    baseLocationOrigin: null,
    device: null,
    deviceWebUrl: null,
    deviceAppUrl: null,
    downloadLink: "https://inistate.com/download"
  }),
  methods: {
    setDevice(device) {
      this.device = device;
    },
    sanitizeDeviceUrl(url) {
      const paramString = url.split('?')[1];
      const searchParams = new URLSearchParams(paramString);
      searchParams.delete("wsId");
      searchParams.delete("accessToken");
      searchParams.delete("refreshToken");
      searchParams.delete("builder");
      searchParams.delete("origin");
      searchParams.delete("refresh");
      searchParams.delete("runas");
      return `${url.split('?')[0]}${Boolean(searchParams.toString()) ? `?${searchParams.toString()}` : ''}`;
    },
    reloadDevice() {
      this.$refs["fts-device"].reload();
    },
    clipboardOnSuccess() {
      this.$alertSuccess("Copied to clipboard.");
    },
    clipboardOnError() {
      this.$alertError();
    }
  },
  created() {
    window.appName = "inistate-builder";
    this.Web = "web";
    this.PhonePortrait = "phonePortrait";
    this.PhoneLandscape = "phoneLandscape";
    this.PadPortrait = "padPortrait";
    this.PadLandscape = "padLandscape";
  },
  async mounted() {
    const workspaceId = $cookies.get('wsId');
    const accessToken = LocalStorageService.getAccessToken();
    const refreshToken = LocalStorageService.getRefreshToken();
    
    this.isReady = true;
    this.setDevice("phonePortrait");

    const origin = webAppConfig.baseURL;
    const query = `accessToken=${accessToken}&refreshToken=${refreshToken}&wsId=${workspaceId}&origin=${origin}`;
    this.baseLocationOrigin = webAppConfig.baseLocationOrigin;
    this.deviceWebUrl = `${webAppConfig.previewWebURL}/#/dashboard?${query}`;
    this.deviceAppUrl = `${webAppConfig.previewAppURL}/?${query}`;
  }
}
</script>

<style lang="scss">
$sidenav-width: 310px;

.layout__sidenav.layout__sidenav--collapsed + .layout__main {
  .fts-lite-device-preview .device-preview__left {
    display: block;
  }
}

.fts-lite-device-preview {
  height: 100%;
  display: flex;
  background-color: var(--inistate-color-shade-white);
  color: var(--inistate-text-primary);
  overflow: auto;
  .device-preview__left {
    display: none;
    min-width: $sidenav-width;
    max-width: $sidenav-width;
    flex-shrink: 0;
  }
  .device-content {
    min-width: 450px;
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 3rem 2rem;
    overflow: hidden;
    > * {
      flex: 1;
    }
  }
  .device-preview__right {
    min-width: $sidenav-width;
    max-width: $sidenav-width;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
    padding-right: 2.5rem;
  }
  .device-preview__onboarding {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.5rem;
    border: 1px solid var(--inistate-color-neutral-200);
    border-radius: var(--inistate-rounded-8);
    background-color: var(--inistate-color-shade-white);
    .onboarding-title {
      margin-bottom: 1rem;
      font-size: var(--inistate-text-label-14);
      line-height: var(--inistate-text-label-14--line-height);
    }
    .onboarding-qr-code {
      height: 180px;
      width: 180px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1rem;
      border: 1px solid var(--inistate-color-neutral-200);
      border-radius: var(--inistate-rounded-8);
    }
    .onboarding-seperator {
      margin-bottom: 1rem;
      font-size: var(--inistate-text-label-12);
      line-height: var(--inistate-text-label-12--line-height);
      color: var(--inistate-text-secondary-color);
    }
    .onboarding-link-btn {
      width: 180px;
      font-weight: var(--inistate-font-weight-light);
    }
  }
}
</style>